import { get } from 'lodash-es';
import { SearchParamsEnum } from 'utils/enums';

const byInitialValues = (state: any) => {
  const query = get(state, 'resultList.searchQuery');
  return {
    [SearchParamsEnum.companyName]: get(query, SearchParamsEnum.companyName),
    [SearchParamsEnum.region]: get(query, SearchParamsEnum.region),
    [SearchParamsEnum.zipCode]: get(query, SearchParamsEnum.zipCode),
    [SearchParamsEnum.spot]: get(query, SearchParamsEnum.spot),
  };
};

export default byInitialValues;
